import * as R from 'ramda';
import SelectInput from '../../../../uikit/input/SelectInput';
import React from 'react';

const HealthAdditionalInformations = ({ ccn }) => {
  const insurer = R.path(['SANTE', 'insurer'], ccn);

  return <div style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(2,minmax(0,1fr))',
    alignItems: 'center',
    justifyItems: 'end',
    rowGap: '1rem',
    columnGap: '1rem',
    width: '550px',
    marginTop: '50px'
  }}>
    <div style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
      {'Régime social de l\'entreprise *'}
    </div>

    <SelectInput
      options={[{ label: 'Régime Général' }]}
      value="Régime Général"
      disabled
    />

    <div style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
      Assureur *
    </div>

    <SelectInput
      options={[{ label: insurer }]}
      value={insurer}
      disabled
    />
  </div>;
};

export default HealthAdditionalInformations;
